import { http } from '../../config/axios'

export default function putMotorCreditoFormula(motorCreditoFormula: any): Promise<string> {
  return http
    .put('api/motorcreditoformula', motorCreditoFormula)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro put motor credito formula', error)
      throw Error(error.response.data)
    })
}
